const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.PRODUCTION_MACHINES)

export const apiProductionMachines = {
	fetchProductionMachines: async (
		filters: any,
		archives: boolean = false,
		page: number = 1,
		perPage: number = 25,
	): Promise<IApiResponseModel<IProductionMachineModel[]>> => {
		const query = createQuery({ page, perPage }, filters)

		const { data, meta } = await apiCommon<IProductionMachine[]>(`${groupPrefix}${archives ? '/archives' : ''}`, {
			method: 'GET',
			...query,
		})

		return { data: data.map(d => ProductionMachine(d)), meta }
	},

	archiveProductionMachine: async (id: number): Promise<IApiResponseModel<any>> => {
		const { data, meta } = await apiCommon<any>(`${groupPrefix}/${id}/archive`, {
			method: 'POST',
		})

		return { data, meta }
	},

	setMachineArchiveStatus: async (id: number, archived: boolean): Promise<IApiResponseModel<any>> => {
		const { data, meta } = await apiCommon<any>(`${groupPrefix}/${id}/manage-status`, {
			method: 'POST',
			body: { status: archived },
		})

		return { data, meta }
	},

	fetchProductionMachineByID: async (id: number): Promise<IApiResponseModel<IProductionMachineModel>> => {
		const { data, meta } = await apiCommon<IProductionMachine>(`${groupPrefix}/${id}`, {
			method: 'GET',
		})

		return { data: ProductionMachine(data), meta }
	},

	createProductionMachine: async (
		payload: IProductionMachineCreatePayload,
	): Promise<IApiResponseModel<IProductionMachineModel>> => {
		const { data, meta } = await apiCommon<IProductionMachine>(`${groupPrefix}`, {
			method: 'POST',
			body: payload,
		})

		return { data: ProductionMachine(data), meta }
	},

	updateProductionMachine: async (
		payload: IProductionMachineUpdatePayload,
	): Promise<IApiResponseModel<IProductionMachineModel>> => {
		const { data, meta } = await apiCommon<IProductionMachine>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		return { data: ProductionMachine(data), meta }
	},

	fetchProductionMachineTypes: async (): Promise<IApiResponseModel<IProductionMachineTypeModel[]>> => {
		const { data, meta } = await apiCommon<IProductionMachineType[]>(`${groupPrefix}/types`, {
			method: 'GET',
		})

		return { data: data.map(d => ProductionMachineType(d)), meta }
	},

	fetchProductionMachinePerformanceParameters: async (): Promise<
		IApiResponseModel<IProductionMachinePerformanceParameterModel[]>
	> => {
		const { data, meta } = await apiCommon<IProductionMachinePerformanceParameter[]>(
			`${groupPrefix}/performance-parameters`,
			{
				method: 'GET',
			},
		)

		return { data: data.map(ProductionMachinePerformanceParameter), meta }
	},

	fetchProductionMachineChangeovers: async (): Promise<IApiResponseModel<IProductionMachineChangeoverModel[]>> => {
		const { data, meta } = await apiCommon<IProductionMachineChangeover[]>(`${groupPrefix}/machine-changeovers`, {
			method: 'GET',
		})

		return { data: data.map(d => ProductionMachineChangeover(d)), meta }
	},
}
